import classNames from 'classnames';
import { Utils } from '../../../Common/Utils';
import {
    reportMediaFinished,
    reportMediaPaused,
    reportMediaStarted,
} from '../exerciseAPI';
import { MusicalNoteIcon } from '../icons';
import { ExerciseDto } from '../interfaces';

type Props = {
    exercise: ExerciseDto;
    duration: string | number;
    src: string;
    type: string;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
};
export function AudioPlayer({
    exercise,
    duration,
    src,
    type,
    children,
    className,
    ...props
}: Props) {
    const moduleId = exercise.ModuleId;
    const exerciseId = { Value: exercise.Id };
    const durationInSeconds =
        typeof duration === 'string'
            ? Utils.timeSpanStringToSeconds(duration)
            : duration;

    return (
        <div
            {...props}
            className={classNames(
                className,
                'rounded-[20px] border border-cool-grey p-20',
            )}
        >
            <div className="mb-20 flex">
                <div
                    className={classNames(
                        'rounded-[16px] bg-vibrant-blue-10p',
                        'flex items-center justify-center',
                        'mr-10 h-[52px] w-[52px]',
                    )}
                >
                    <MusicalNoteIcon />
                </div>
                <div className="flex flex-col justify-center">{children}</div>
            </div>
            <audio
                controls
                className="w-full"
                onPlay={(e) => {
                    const currentTime = e.currentTarget.currentTime;
                    reportMediaStarted(moduleId, exerciseId, src, currentTime);
                }}
                onPause={(e) => {
                    const currentTime = e.currentTarget.currentTime;
                    const pauseBuffer = 2;
                    if (currentTime + pauseBuffer < durationInSeconds) {
                        reportMediaPaused(
                            moduleId,
                            exerciseId,
                            src,
                            currentTime,
                        );
                    } else {
                        reportMediaFinished(moduleId, exerciseId, src);
                    }
                }}
            >
                <source src={src} type={type} />
            </audio>
        </div>
    );
}
